<template>
    <div class="checkout-radio relative group">
        <input
            :id="id"
            v-model="localValue"
            type="radio"
            class="sr-only"
            :value="address.id"
            :name="`${type}Id`"
            required
        >

        <label :for="id" class="flex items-center p-2 bg-secondary-100 mb-2">
            <span class="checkout-radio__radio"></span>

            <span class="block flex-1 pr-10 text-sm leading-tight">
                <span>{{ address.fullName }}<br>{{ address.address }}</span>
            </span>
        </label>

        <button
            class="group-hover:block absolute right-0 align-y mr-4 w-6 h-6 font-light text-2xl leading-none"
            :class="{ loading, hidden: !loading }"
            :disabled="loading"
            @click.prevent="onDeleteAddress"
        >
            &times;
        </button>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('cart');

export default {
    props: {
        modelValue: {
            type: String,
            required: true,
        },
        address: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },

    emits: ['update:modelValue'],

    data() {
        return {
            loading: false,
        };
    },

    computed: {
        id() {
            return `${this.type}-${this.address.id}`;
        },

        localValue: {
            get() {
                return this.modelValue;
            },
            set(newValue) {
                this.$emit('update:modelValue', newValue);
            },
        },
    },

    methods: {
        ...mapActions([
            'deleteAddress',
        ]),

        async onDeleteAddress() {
            if (confirm('Are you sure you want to delete this address')) {
                this.loading = true;

                await this.deleteAddress(this.address.id);

                this.loading = false;
            }
        },
    },
};
</script>
